
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-scissors-line',
      title: 'Lawn Mowing',
      description: 'Professional lawn mowing service for every quarter acre of your property.',
      price: '$40',
      unit: 'per 1/4 acre'
    },
    {
      icon: 'ri-crop-line',
      title: 'Edging',
      description: 'Clean, precise edging to give your lawn a professional finished look.',
      price: '$15',
      unit: 'per service'
    },
    {
      icon: 'ri-windy-line',
      title: 'Blowing',
      description: 'Thorough cleanup of grass clippings and debris from all surfaces.',
      price: '$5',
      unit: 'per service'
    },
    {
      icon: 'ri-plant-line',
      title: 'Bush Trimming',
      description: 'Expert trimming and shaping of bushes and shrubs for healthy growth.',
      price: '$15',
      unit: 'per service'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto mb-8">
            It all started with one idea — take something simple, like cutting grass, and turn it into something that actually means something. Whether you're trying to keep your yard clean, start fresh on a new property, or just want to come home to something that looks good — we've got you covered.
          </p>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto mb-8">
            We handle everything from mowing and trimming to cleanup and maintenance, but more than that, we bring care and consistency to every job. It's not just about lawns — it's about helping people take pride in their space.
          </p>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            No matter how big or small the project, we show up, we work hard, and we make sure it's done right. Because your yard deserves the same effort we put into building this business from the ground up.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="p-6">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-green-600 text-xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-600 mb-1">{service.price}</div>
                  <div className="text-sm text-gray-500">{service.unit}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-green-600 text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Request Service Quote
          </button>
        </div>
      </div>
    </section>
  );
}
